import { Collection } from 'core/model';
import CustomReportModel from './CustomReportModel';

export default class CustomReportsCollection extends Collection {
  get url() {
    return '/api/ui/recon/customReports';
  }

  get model() {
    return CustomReportModel;
  }
}
